import Vue from "vue";
import Vuex from "vuex";

import classes from "./classes.module";
import connection from "./connection.module";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    /**
     * Явный выход. Пока учитель не вышел сам, подтверждённую сессию показываем
     * в кабинете, даже если браузер открыл форму входа (например, по закладке
     * `#/login` или по старой ссылке оператора с уже погашенным кодом).
     */
    explicitLogout: false
  },
  mutations: {
    setExplicitLogout(state, value) {
      state.explicitLogout = Boolean(value);
    }
  },
  actions: {},
  modules: {
    classes,
    connection
  }
});
